export default __webpack_public_path__ + "static/media/two.1a88307f.jpg";